export default {
  // العناوين الرئيسية
  editProfile: "تعديل الملف الشخصي",
  saveChanges: "حفظ التغييرات",
  loadingProfile: "جاري تحميل الملف الشخصي...",
  pleaseWait: "يرجى الانتظار بينما نقوم بجلب بياناتك",

  // حقول النموذج
  firstName: "الاسم الأول",
  lastName: "اسم العائلة",
  emailAddress: "عنوان البريد الإلكتروني",
  position: "المنصب",
  contactInformation: "معلومات الاتصال",
  city: "المدينة",
  country: "الدولة",
  state: "الولاية/المحافظة",

  // أرقام الهواتف
  phoneNumbers: "أرقام الهواتف",
  addPhone: "إضافة رقم هاتف",
  addAnotherPhone: "إضافة رقم هاتف آخر",
  noPhoneNumbersAdded:
    "لم يتم إضافة أرقام هواتف. انقر على 'إضافة رقم هاتف' لإضافة واحد.",
  phone: "رقم الهاتف",
  phoneNumber: "رقم الهاتف",
  enterPhoneNumber: "أدخل رقم الهاتف",
  removeThisPhoneNumber: "إزالة هذا الرقم",
  removePhoneNumber: "إزالة رقم الهاتف",

  // الروابط الاجتماعية
  links: "الروابط",
  addLink: "إضافة رابط",
  addAnotherLink: "إضافة رابط آخر",
  selectSocialPlatform: "اختر منصة التواصل الاجتماعي",
  enterProfileUrl: "أدخل رابط ملفك الشخصي",
  removeThisLink: "إزالة هذا الرابط",
  removeLink: "إزالة الرابط",

  // رسائل النجاح
  profileUpdatedSuccessfully: "تم تحديث الملف الشخصي بنجاح!",
  profileImageUpdatedSuccessfully: "تم تحديث صورة الملف الشخصي بنجاح!",
  success: "نجاح",

  // رسائل الخطأ
  error: "خطأ",
  validationError: "خطأ في التحقق",
  unexpectedError: "حدث خطأ غير متوقع",
  failedToLoadProfileData: "فشل تحميل بيانات الملف الشخصي",
  failedToSaveProfileData: "فشل حفظ بيانات الملف الشخصي",
  failedToUploadProfileImage: "فشل رفع صورة الملف الشخصي",
  pleaseCorrectInvalidPhones: "يرجى تصحيح أرقام الهواتف غير الصحيحة قبل الحفظ.",

  // ProfileCard
  changePhoto: "تغيير الصورة",
  socialLinks: "الروابط الاجتماعية",

  // Upload errors
  uploadError: "خطأ في الرفع",
  fileSizeExceedsLimit: "حجم الملف يتجاوز الحد المسموح به وهو 50 ميجابايت",
  failedToUploadImage: "فشل رفع الصورة",

  // أزرار
  ok: "موافق",
};
